import { TMCCommonContextService } from '@sdbn/tmc-common';
import { debounceTime } from 'rxjs/operators';
import { ComponentSelectionStorageService } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CustomFilter, CustomFilterType } from '@sdbn/tmc-common';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ContextChange } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { PersonalVisitFilterModel, VisitorType } from '../personal-visit-filter.model';
import { WidgetStyle } from '@sdbn/common';

export class TypeFilter {

  /** Uniquely identifies a quickfilter. */
  id: string;
  /** css style of image show for this filter. */
  icon: string;
  /** dictionary key used as tooltip. */
  title: string;
  /** if this filter is currently selected. */
  selected: boolean;

  visitorType: VisitorType;
}

const CUSTOM_FILTER_SELECTION_KEY = 'personal-visit.custom-filter-selection';


@Component({
    selector: 'app-personal-visit-filter',
    templateUrl: './personal-visit-filter.component.html',
    styleUrls: ['./personal-visit-filter.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PersonalVisitFilterComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  valueAdjusting = false;

  filters: CustomFilter[] = [];
  filterSubscription: Subscription;
  selectedCustomFilter: number;

  scopeFilters = new Array<TypeFilter>();

  filterFormGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    private componentSelectionStorageService: ComponentSelectionStorageService,
    private tmcCommonContextService: TMCCommonContextService
  ) {
    super();
    const filter = new TypeFilter();
    filter.id = 'person';
    filter.icon = 'fa-light fa-sharp fa-user'; // we use the same CSS as in table
    filter.title = 'tmc.visit.overview.visitors.filter.visitor.title';
    filter.visitorType = VisitorType.VISITOR;
    this.scopeFilters.push(filter);

    const filterGroup = new TypeFilter();
    filterGroup.id = 'group';
    filterGroup.icon = 'fa-light fa-sharp fa-users'; // we use the same CSS as in table
    filterGroup.title = 'tmc.visit.overview.visitors.filter.visitorgroup.title';
    filterGroup.visitorType = VisitorType.VISITORGROUP;
    this.scopeFilters.push(filterGroup);

    this.filterFormGroup.addControl('filterText', new FormControl(null, []));
    this.filterFormGroup.addControl('customFilter', new FormControl(null, []));
    this.filterFormGroup.valueChanges.pipe(debounceTime(300)).subscribe(
      value => {
        if (this.filterFormGroup.dirty) {
          this.handleFilterChanged();
        }
      }
    );
  }

  ngOnInit() {

    this.filterSubscription = this.tmcCommonContextService.changed.subscribe(next => {
      this.filters = this.tmcCommonContextService.customFilters.filter(f => f.type === CustomFilterType.VISITOR_LIST);
      this.restoreFilter();
    });

    this.filters = this.tmcCommonContextService.customFilters.filter(f => f.type === CustomFilterType.VISITOR_LIST);
    this.restoreFilter();
  }

  ngOnDestroy() {

    super.ngOnDestroy();

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

  private restoreFilter() {

    try {
      const model: PersonalVisitFilterModel = this.componentSelectionStorageService.get(CUSTOM_FILTER_SELECTION_KEY);

      if (model != null) {

        const values: any = {};

        // restore custom filter selection
        const filterExternalKey = model.filterExternalKey;
        if (filterExternalKey != null && this.filters != null) {
          const result = this.filters.find(f => f.externalKey === filterExternalKey);
          values.customFilter = result?.externalKey || '-1';
        }
        // restore text filter
        if (model.filterText != null) {
          values.filterText = model.filterText;
        }

        this.filterFormGroup.reset(values);
      }
    } finally {
      this.handleFilterChanged();
    }
  }

  public applyQuickFilter(item: TypeFilter) {
    item.selected = !item.selected;
    this.handleFilterChanged();
  }

  private handleFilterChanged() {
    /** we need to fire a new model instance, otherwise the destined input will not react to changes properly */
    const selectedFilterExternalKey = this.filterFormGroup.controls.customFilter.value;

    const model = new PersonalVisitFilterModel();
    model.filterText = this.filterFormGroup.controls.filterText.value;
    model.filterExternalKey = selectedFilterExternalKey != null ? selectedFilterExternalKey : '-1';
    const selectedFilter = this.filters.find(f => f.externalKey === model.filterExternalKey);
    if (selectedFilter != null) {
      model.tableColumns = selectedFilter.tableColumns;
      model.sortColumn = selectedFilter.sortColumn;
      model.sortDescending = selectedFilter.sortDescending;
    }
    for (const scopeFilter of this.scopeFilters) {
      if (scopeFilter.selected) {
        model.visitorTypes.push(scopeFilter.visitorType);
      }
    }
    this.componentSelectionStorageService.save(CUSTOM_FILTER_SELECTION_KEY, model);
    this.dashboardContext.setContextValue('visitor-selection', model);
  }

  onContextChange(contextChange: ContextChange) {
  }
  onSetElementAndContext() {
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
